<template>
  <div id="app" rel="app">
    <div :class="{'changeOpacity' : viewVeil}"></div>
    <header-main/>
    <router-view @changeVeil="changeVeil"/>
    <footer-main/>
    <!-- loading / spinner -->
    <div v-if="viewHeart" id="loader" class="modal-backdrop loading pantallaCarga">
      <div class="heartContainer"><img class="medium-spinner" src="./assets/images/loader.gif" alt="Loading"></div>
    </div>
    <!-- loading / spinner end  -->  
  </div>
</template>

<script>
  export default {
  name: 'App',
  data(){
    return{
      viewVeil:true,
      viewHeart:false
    }
  },
  methods:{
    changeVeil(val,val2){
      this.viewVeil=val
      this.viewHeart=val2
    }
  }
}

</script>

<style>

@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600);
@import url(https://fonts.googleapis.com/css?family=Roboto+Slab:400,700);
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
 #app{
   position:absolute;
   width:100%;
   height:100%;
 }

</style>



// WEBPACK FOOTER //
// ./src/App.vue